import Button from '../Button'
import PostCard from '../PostCard'
import Reveal from '../Reveal'
import { Section, SectionHead } from '../Section'
import { posts } from '../../articles'

/** "Hausverwalter Insights" - the three most recent articles. */
export default function InsightsTeaser({ count = 3 }) {
  const latest = posts.slice(0, count)
  if (latest.length === 0) return null

  return (
    <Section>
      <SectionHead
        eyebrow="Hausverwalter Insights"
        title="Aktuelle Einblicke, Ratgeber und Expertenwissen"
        lead="Praxiswissen für Eigentümer und Mieter - von der Nebenkostenabrechnung bis zum richtigen Lüften."
      />

      <Reveal group className="grid grid--3">
        {latest.map((post) => (
          <PostCard post={post} key={post.slug} />
        ))}
      </Reveal>

      <div className="btn-row" style={{ marginTop: 'var(--s-7)' }}>
        <Button to="/insights" variant="outline" icon="arrowRight">
          Weitere Blogartikel
        </Button>
      </div>
    </Section>
  )
}
